import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import type { AdminApi } from "../api/client.js";
import { Card } from "../components/Card.js";
import { Badge } from "../components/Badge.js";

type Props = { api: AdminApi };

export function HealthPage({ api }: Props) {
  const status = useQuery({
    queryKey: ["admin", "google-status"],
    queryFn: () => api.getGoogleStatus(),
  });

  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? "(unset)";
  const env = import.meta.env.VITE_APP_ENV ?? "(unset)";

  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <Card title="Environment">
        <dl className="grid gap-2 text-sm">
          <Row label="Environment">
            <Badge tone={env === "production" ? "slate" : "rose"}>{env}</Badge>
          </Row>
          <Row label="API base">
            <code className="text-xs">{apiBaseUrl}</code>
          </Row>
        </dl>
      </Card>

      <Card title="Google Calendar">
        {status.isPending ? (
          <p className="text-sm text-slate-600">Checking…</p>
        ) : status.data?.connected ? (
          <dl className="grid gap-2 text-sm">
            <Row label="Status">
              <Badge tone="emerald">Connected</Badge>
            </Row>
            <Row label="By">{status.data.connected_by_email ?? "—"}</Row>
          </dl>
        ) : (
          <div className="grid gap-2 text-sm">
            <p>
              <Badge tone="amber">Not connected</Badge>
            </p>
            <p>
              <Link
                to="/settings/calendar"
                className="text-blue-700 hover:underline"
              >
                Connect Google Calendar →
              </Link>
            </p>
          </div>
        )}
      </Card>
    </div>
  );
}

function Row({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="grid grid-cols-[8rem_1fr] gap-3">
      <dt className="text-slate-500">{label}</dt>
      <dd className="text-slate-800">{children}</dd>
    </div>
  );
}
